<template>
    <div id="titlebar">
        <top-menu v-if="$vuetify.breakpoint.mdAndUp" />
        <v-app-bar
            :elevation="$vuetify.breakpoint.smAndDown ? 3 : 0"
            :fixed="$vuetify.breakpoint.smAndDown"
            :app="$vuetify.breakpoint.smAndDown"
            :height="$vuetify.breakpoint.mdAndUp ? '138' : '60'"
            class="header-menu-background-color top-bar"
        >
            <v-row class="">
                <v-col v-if="$vuetify.breakpoint.smAndDown" class="pa-0 ma-0 tz-content-wrapper">
                    <!-- menu XS et  SM -->
                    <mobile-menu
                        class="mobile-menu"
                        data-testid="mobile-menu"
                        @setToggleHomeLoading="setToggleHomeLoading"
                    />
                </v-col>

                <v-col v-if="$vuetify.breakpoint.mdAndUp" cols="12" class="pa-0 tz-content-wrapper">
                    <!-- menu MD et + -->
                    <standard-menu
                        data-testid="standard-menu"
                        class="standard-menu"
                        @setToggleHomeLoading="setToggleHomeLoading"
                    />
                </v-col>
            </v-row>
        </v-app-bar>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import MobileMenu from '@/components/bars/mobileHeaderMenu/MobileHeaderMenu';
import StandardMenu from '@/components/bars/standardHeaderMenu/StandardHeaderMenu.vue';
import TopMenu from './bars/topHeaderMenu/TopHeaderMenu';
import { includes } from 'lodash';

export default {
    name: 'title-bar',
    components: {
        MobileMenu,
        StandardMenu,
        TopMenu,
    },
    computed: {
        ...mapGetters({
            getStyle: 'getStyle',
            getEstablishment: 'establishment/getEstablishment',
        }),
    },
    methods: {
        ...mapActions({
            toggleHomeLoading: 'loading/toggleHomeLoading',
        }),
        setToggleHomeLoading(currentPage) {
            this.toggleHomeLoading({ set: true });
            const page = this.$route.fullPath;
            if (includes(page, currentPage)) {
                setTimeout(() => {
                    this.toggleHomeLoading({ set: false });
                }, 1000);
            }
        },
    },
};
</script>

<style scoped lang="scss">
.top-bar {
    border: 1px solid #000;
}
</style>
